import React from 'react';
import { connect } from 'react-redux';
import { ConnectedProps } from 'types/utils';
import { memo } from 'common/hocs/memo';
import { BrandShelfProductCard } from 'common/components/sponsored-carousel/product-card/brandshelf-product-card';
import { SponsoredProductCard } from 'common/components/sponsored-carousel/product-card/sponsored-product-card';
import type { ProductOwnProps } from 'features/products/components/product/product.types';
import { useProductLogic } from 'features/products/components/product/use-product-logic';
import { mapDispatchToProps, mapStateToProps } from 'features/products/components/product/product-maps';

type ProductLogicProps = ProductOwnProps &
  ConnectedProps<typeof mapStateToProps, typeof mapDispatchToProps> & {
    isBrandShelf?: boolean;
    isSimplifiedVariant?: boolean;
    isSponsored?: boolean;
  };
const ProductLogic = memo<ProductLogicProps>(function ProductLogic({
  isBrandShelf,
  isSimplifiedVariant,
  className,
  type = 'large-card',
  elementBlock = 'not set',
  product,
  isBasketLoading,
  inBasket,
  qty = 0,
  productPosition,
  addToBasket,
  removeFromBasket,
  ratings,
  updateCartItem,
  inWidget,
  inShoppingList,
  addToShoppingList,
  removeFromShoppingList,
  isSponsored,
}) {
  const {
    productRef,
    review,
    label,
    handleAddToCart,
    handleUpdateCart,
    handleRemoveFromCart,
    onClick,
    toggleShoppingList,
  } = useProductLogic({
    elementBlock,
    product,
    qty,
    productPosition,
    addToBasket,
    removeFromBasket,
    ratings,
    updateCartItem,
    addToShoppingList,
    removeFromShoppingList,
  });

  if (isBrandShelf)
    return (
      <BrandShelfProductCard
        className={className}
        product={product}
        productPosition={productPosition}
        ref={productRef}
        type={type}
        label={label}
        isBasketLoading={isBasketLoading}
        inBasket={inBasket}
        qty={qty}
        onClick={onClick}
        onCartAdd={handleAddToCart}
        onQtyUpdate={handleUpdateCart}
        onCartRemove={handleRemoveFromCart}
        onShoppingListToggle={toggleShoppingList}
        ratings={review}
        inWidget={inWidget}
        inShoppingList={inShoppingList}
        isSponsored={isSponsored}
      />
    );
  return (
    <SponsoredProductCard
      className={className}
      product={product}
      productPosition={productPosition}
      ref={productRef}
      type={type}
      label={label}
      isBasketLoading={isBasketLoading}
      inBasket={inBasket}
      qty={qty}
      onClick={onClick}
      onCartAdd={handleAddToCart}
      onQtyUpdate={handleUpdateCart}
      onCartRemove={handleRemoveFromCart}
      onShoppingListToggle={toggleShoppingList}
      ratings={review}
      inWidget={inWidget}
      inShoppingList={inShoppingList}
      isSimplifiedVariant={isSimplifiedVariant}
      isSponsored={isSponsored}
    />
  );
});

export const Product = connect(mapStateToProps, mapDispatchToProps)(ProductLogic);
